module.exports = __webpack_public_path__ + "img/Dijlat-AL_Ahlam.99e64f32.jpg";